import { NavItem } from './Navbar';
import { DesktopNavLink } from './NavLinks';
import LogoutLink from './LogoutLink';
import NavFooter from './NavFooter';
import CardCodeDropdown from "@/navigation/CustomerIdDropdown";

function DesktopNavBar({ navItems }: { navItems: NavItem[] }) {
    
    return (
        <nav className="hidden lg:flex flex-col overflow-auto w-64 h-dvh bg-white border-r border-gray-100">
            <div className="p-6 flex flex-col gap-2 items-start justify-between border-b border-gray-100">
                <h1 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-400">
                    Foundation Elite
                </h1>
                <div className="w-full mt-2">
                    <CardCodeDropdown/>
                </div>
            </div>
            <ul className="flex-grow space-y-1.5 px-4 py-6">
                {navItems.map((item) => (
                    <li key={item.name}>
                        <DesktopNavLink item={item} />
                    </li>
                ))}
            </ul>
            <div className="border-t border-slate-200">
                <LogoutLink />
            </div>
            <NavFooter />
        </nav>
    );
}

export default DesktopNavBar;
